import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PartnerLicensePackageUsageRateGauge from './PartnerLicensePackageUsageRateGauge';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';
import { PartnerLicensePackageUsageRateListService } from '../../services/CustomerSuccessKpiListService';

class PartnerLicensePackageUsageRateCompanyGaugeContainer extends React.Component {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    PartnerLicensePackageUsageRateListService.load();
  }

  render() {
    const data = toJS(PartnerLicensePackageUsageRateListService.getByCompanyId(this.props.companyId));
    return (
      <PartnerLicensePackageUsageRateGauge
        loading={
          PartnerLicensePackageUsageRateListService.fetchCurrent.fetching ||
          PartnerLicensePackageUsageRateListService.fetchPrevious.fetching
        }
        currentValue={data.current}
        previousValue={data.previous}
        onClickHistory={() =>
          CustomerSuccessHistoryService.openDialog('PARTNER_LICENSE_PACKAGE_USAGE', this.props.companyId)
        }
        formatter={PartnerLicensePackageUsageRateListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerLicensePackageUsageRateCompanyGaugeContainer);
